import { Controller } from "stimulus"
import L from 'leaflet'

// Fix webpack icon paths for Leaflet default markers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default class extends Controller {
  static targets = [ "map" ]

  connect() {
    this.map = this.loadMap()
    this.leafletMarkers = []
    this._cardListeners = []

    var markers = this.mapTarget.dataset.markers
    var marker = this.mapTarget.dataset.marker

    if (marker != null) {
      this.setMarker(this.map)
    } else if (markers != null) {
      this.setLocationDot(this.map)
      this.setMarkers(this.map, markers)
    }
  }

  disconnect() {
    this._cardListeners.forEach(({ card, event, handler }) => {
      card.removeEventListener(event, handler)
    })
    this._cardListeners = []
    this.leafletMarkers.forEach(m => m.remove())
    this.leafletMarkers = []
    if (this.map) {
      this.map.remove()
      this.map = null
    }
  }

  loadMap() {
    var baseCenter = [48.8534, 2.3488]
    const map = L.map(this.mapTarget).setView(baseCenter, 6)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map)
    return map
  }

  setMarker(map) {
    const marker = JSON.parse(this.mapTarget.dataset.marker)
    const leafletMarker = L.marker([marker.lat, marker.lng]).addTo(map)
    this.leafletMarkers.push(leafletMarker)
    map.setView([marker.lat, marker.lng], 18)
  }

  setLocationDot(map) {
    if (this.mapTarget.dataset.dot) {
      const dot = JSON.parse(this.mapTarget.dataset.dot)
      const circleMarker = L.circleMarker([dot.lat, dot.lng], {
        radius: 7,
        fillColor: '#00F',
        fillOpacity: 0.6,
        color: '#00A',
        opacity: 0.9,
        weight: 1
      }).addTo(map)
      this.leafletMarkers.push(circleMarker)

      const radius = this.mapTarget.dataset.radius
      if (radius) {
        const circle = L.circle([dot.lat, dot.lng], {
          color: "#16C995",
          opacity: 0.8,
          weight: 2,
          fillColor: "#FFFFFF",
          fillOpacity: 0.1,
          radius: JSON.parse(radius) * 1000,
        }).addTo(map)
        this.leafletMarkers.push(circle)
      }
    }
  }

  setMarkers(map, markers) {
    markers = JSON.parse(markers)
    const mapMarkersArray = []
    if (markers) {
      markers.forEach(marker => {
        var mapMarker = L.marker([parseFloat(marker.lat), parseFloat(marker.lng)], {
          pharmacyId: marker.id
        }).addTo(map)

        mapMarker.bindPopup(marker.infowindow)
        mapMarkersArray.push(mapMarker)
        this.leafletMarkers.push(mapMarker)

        mapMarker.on('click', function() {
          mapMarkersArray.forEach(function(m) {
            m.closePopup()
          })
          mapMarker.openPopup()
        })
      })

      // open marker popup when hovering the corresponding card
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      if (!isMobile) {
        const cards = document.querySelectorAll(".index-card")
        cards.forEach(card => {
          var markerHover = mapMarkersArray.find(m => m.options.pharmacyId === parseInt(card.dataset.id))
          if (!markerHover) return
          const onEnter = () => markerHover.openPopup()
          const onLeave = () => markerHover.closePopup()
          card.addEventListener("mouseenter", onEnter)
          card.addEventListener("mouseleave", onLeave)
          this._cardListeners.push({ card, event: "mouseenter", handler: onEnter })
          this._cardListeners.push({ card, event: "mouseleave", handler: onLeave })
        })
      }
    }
    if (markers && markers.length > 0) {
      this.fitMap(map, markers)
    }
  }

  fitMap(map, markers) {
    var bounds = L.latLngBounds(markers.map(m => [m.lat, m.lng]))
    map.fitBounds(bounds)
  }
}
